import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {
  Notice,
  NoticeCreateRequest,
  NoticeCreateResponse,
  NoticeDetails,
  NoticeUpdateRequest,
  NoticeUpdateResponse
} from '@ms-organization-entities';
import {NoticeDependency, PriorityPatchRequest} from '@primatoo-ms-organization';
import {ApiClientConfig} from '../api-client-config';
import {DataProtectionGovernanceService} from '../interface/data-protection-governance-service';
import {ColumnWithLocalization} from 'it/primatoo/openapi/api/org/schemas/common/ColumnWithLocalization';

@Injectable({
  providedIn: 'root'
})
export class NoticeService extends DataProtectionGovernanceService {
  private readonly endpoint: string;

  constructor(
    @Inject(ApiClientConfig) private config,
    public httpClient: HttpClient
  ) {
    super(httpClient);
    this.endpoint = this.config.endPoint + '/api/org/notices/';
  }


  public getNotices(): Observable<Notice[]> {
    const url = this.endpoint;
    return this.httpClient.get<Notice[]>(url);
  }

  setPriority(id: number, request: PriorityPatchRequest): Observable<Notice> {
    const url = `${this.endpoint}${id}/priority`;
    return this.httpClient.patch<Notice>(url, request);
  }

  public findUserColumns(): Observable<ColumnWithLocalization[]> {
    const url = this.endpoint + `columns`;
    return this.httpClient.get<ColumnWithLocalization[]>(url);
  }

  // public updateUserColumns(columnsConfigurationUpsertRequest: ColumnsConfigurationUpsertRequest): Observable<void> {
  //   const url = this.endpoint + 'user-columns';
  //   return this.httpClient.post<void>(url, columnsConfigurationUpsertRequest);
  // }

  public getNoticeById(id: number): Observable<Notice> {
    const url = this.endpoint + id + '/';
    return this.httpClient.get<Notice>(url);
  }

  public deleteNotice(id: number): Observable<Notice> {
    const url = this.endpoint + id + '/';
    return this.httpClient.delete<Notice>(url);
  }

  public createNotice(requestBody: NoticeCreateRequest): Observable<NoticeCreateResponse> {
    const url = this.endpoint;
    return this.httpClient.post<NoticeCreateResponse>(url, requestBody);
  }

  public updateNotice(id: number, requestBody: NoticeUpdateRequest): Observable<NoticeUpdateResponse> {
    const url = this.endpoint + id + '/';
    return this.httpClient.put<NoticeUpdateResponse>(url, requestBody);
  }

  public getNoticeDetails(id: number): Observable<NoticeDetails> {
    const url = this.endpoint + id + '/details';
    return this.httpClient.get<NoticeDetails>(url);
  }

  public getNoticeDependency(id: number): Observable<NoticeDependency> {
    const url = this.endpoint + id + '/dependency';
    return this.httpClient.get<NoticeDependency>(url);
  }

  getEndPointV1(): string {
    return this.endpoint;
  }
}
